import MapScreen from 'features/moveMoney/screens/depositCash/MapScreen/MapScreen';
import React from 'react';

export default function Page() {
  return <MapScreen />;
}
